module.exports = __webpack_public_path__ + "img/MED_FERMENTED_MILK@300x.9c89bd5f.png";